import $ from "jquery";
import "bootstrap"; // bootstrap javascript
import "./css/site.scss";

export async function addPopovers() {
  const popovers = <any>$('[data-toggle="popover"]');
  popovers.popover({
    trigger: "hover",
  });
}

export async function goBack() {
  history.back();
}

export async function historyLength(): Promise<number> {
  return history.length;
}

// https://learn.microsoft.com/en-us/aspnet/core/blazor/file-downloads?view=aspnetcore-6.0
export async function downloadSmallFileFromStream(
  filename: string,
  contentStreamReference: any,
) {
  const arrayBuffer = await contentStreamReference.arrayBuffer();
  const blob = new Blob([arrayBuffer]);
  const url = URL.createObjectURL(blob);
  const anchorElement = document.createElement("a");
  anchorElement.href = url;
  anchorElement.download = filename ?? "";
  anchorElement.click();
  anchorElement.remove();
  URL.revokeObjectURL(url);
}

export async function focusElementWithId(id: string) {
  // focusVisible is an experimental option: https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#focusvisible
  // DevExpress expects it to be set in order to put a border around our focused elements.
  setTimeout(
    // @ts-ignore
    () => document.getElementById(id)?.focus({ focusVisible: true }),
    100,
  );
}

export async function setOnFocus(
  e: Element,
  f: EventListenerOrEventListenerObject,
) {
  e?.removeEventListener("focus", f);
  e?.addEventListener("focus", f);
}
const selectInput = (inputElement: HTMLInputElement) => () =>
  inputElement?.select();
const selectTextArea = (textAreaElement: HTMLTextAreaElement) => () =>
  textAreaElement?.select();
export async function setOnFocusSelectAllOnChildElements(
  parentElement: Element,
  includeTextAreas: boolean,
) {
  if (parentElement == null) return;
  let inputs = parentElement.getElementsByTagName("input");
  for (let i = 0; i < inputs.length; i++) {
    await setOnFocus(inputs[i], selectInput(inputs[i]));
  }
  if (includeTextAreas) {
    let textareas = parentElement.getElementsByTagName("textarea");
    for (let i = 0; i < inputs.length; i++) {
      await setOnFocus(textareas[i], selectTextArea(textareas[i]));
    }
  }
}
export async function setAutocomplete(e: Element) {
  e?.setAttribute("autocomplete", "on");
}
export async function setAutocompleteOnChildElements(parentElement: Element) {
  if (parentElement == null) return;
  let inputs = parentElement.getElementsByTagName("input");
  for (let i = 0; i < inputs.length; i++) {
    let input = inputs[i];
    if (
      ["text", "email"].includes(input.type) &&
      input.name &&
      input.name.startsWith("nmc-")
    )
      await setAutocomplete(input);
  }
}
